module.exports = __webpack_public_path__ + "img/sixpackcarrier21.a6cf5018.jpg";